import Cookies from "js-cookie";

/** * Get value from localStorage first, then fallback to Cookies */
export const getStoredValue = (key) => {
    try {
        const localValue = localStorage.getItem(key);
        if (localValue) {
            return JSON.parse(localValue);
        }

        const cookieValue = Cookies.get(key);
        if (cookieValue) {
            return JSON.parse(cookieValue);
        }

        return null;
    } catch (error) {
        console.error(`Error parsing stored value for key "${key}"`, error);
        return null;
    }
};

/** * Get value from localStorage first, then fallback to Cookies */
export const getStoredMacIDValue = (key) => {
    try {
        const localValue = localStorage.getItem(key);
        if (localValue) {
            return localValue;
        }

        const cookieValue = Cookies.get(key);
        if (cookieValue) {
            return cookieValue;
        }

        return null;
    } catch (error) {
        console.error(`Error parsing stored value for key "${key}"`, error);
        return null;
    }
};

/** * Set value in localStorage (default) or Cookies (if useCookies = true) */
export const setStoredValue = (key, value, useCookies = true) => {
    try {
        const stringified = JSON.stringify(value);

        localStorage.setItem(key, stringified);

        if (useCookies) {
            Cookies.set(key, stringified);
        }

    } catch (error) {
        console.error(`Error setting stored value for key "${key}"`, error);
    }
};

/** * Set value in localStorage (default) or Cookies (if useCookies = true) */
export const setStoredMacIDValue = (key, value, useCookies = true) => {
    try {
        const stringified = value?.toString();

        localStorage.setItem(key, stringified);

        if (useCookies) {
            Cookies.set(key, stringified);
        }

    } catch (error) {
        console.error(`Error setting stored value for key "${key}"`, error);
    }
};

/** * Remove value from both localStorage and Cookies */
export const removeStoredValue = (key) => {
    try {
        localStorage.removeItem(key);
        Cookies.remove(key);
    } catch (error) {
        console.error(`Error removing stored value for key "${key}"`, error);
    }
};
